export class ResponseError extends Error {
  constructor(
    message: string,
    public response: Omit<Response, "text" | "json" | "body">,
    public body?: ResponseErrorBody,
  ) {
    super(message);
  }

  get correlationId() {
    return this.response.headers.get("X-Correlation-Id").slice(-8) || undefined;
  }
}

export interface ResponseErrorBody {
  message: string;
  error: string;
}
